import { useEffect } from 'react';

/* eslint-env browser */
function useOutsideClicked(ref, onClick) {
  useEffect(() => {
    function handleClickOutside(event) {
      var _ref$current;
      if (onClick && ref.current && !((_ref$current = ref.current) !== null && _ref$current !== void 0 && _ref$current.contains(event.target))) {
        onClick();
      }
    }
    // Bind the event listener
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [ref, onClick]);
}

export { useOutsideClicked as default };
//# sourceMappingURL=useOutsideClicked.js.map
